import SidebarItem from '../../components/layout/sidebar/SidebarItem';
import Sidebar from '../../components/layout/sidebar/Sidebar';
import 'boxicons';

const AccountSidebar = ({tab}) => {


    return (
        <Sidebar defaultActiveKey={tab}>
            <SidebarItem eventKey={"dashboard"} to={'/account/dashboard'}>
                <box-icon color='white' type='solid' name='dashboard'></box-icon>
                <span className="mx-4 d-none d-lg-inline pe-4">Dashboard</span>
            </SidebarItem>
            <SidebarItem eventKey={"details"} to={'/account/details'}>
                <box-icon color='white' name='user-detail' type='solid' ></box-icon>
                <span className="mx-4 d-none d-lg-inline pe-4">Details</span>
            </SidebarItem>
            <SidebarItem eventKey={"security"} to={'/account/security'}>
                <box-icon color='white' type='solid' name='lock'></box-icon>
                <span className="mx-4 d-none d-lg-inline pe-4">Security</span>
            </SidebarItem>
            <SidebarItem eventKey={"payments"} to={'/account/payments'} disabled={true}>
                <box-icon color="#AAA" name='credit-card' type='solid' ></box-icon>
                <span className="mx-4 d-none d-lg-inline text-white-50 pe-4">Payment</span>
            </SidebarItem>
        </Sidebar>
    );
}

export default AccountSidebar;